import store from '@/store';

import PopupAlert from '@/components/base/PopupAlert.vue';
import PopupConfirm from '@/components/base/PopupConfirm.vue';
import PopupPrompt from '@/components/base/PopupPrompt.vue';

export default {
  type: {
    alert: 'alert',
    confirm: 'confirm',
  },

  addAlert(text, desc = '') {
    const component = PopupAlert;
    const args = [text, desc];
    return this.add({ component, args });
  },

  addConfirm(text, desc = '') {
    const component = PopupConfirm;
    const args = [text, desc];
    return this.add({ component, args });
  },

  addPrompt(text, desc = '', defValue = '') {
    const component = PopupPrompt;
    const args = [text, desc, defValue];
    return this.add({ component, args });
  },

  add(popup) {
    const promise = new Promise((resolve) => {
      popup.resolve = resolve; // eslint-disable-line no-param-reassign
    });

    store.commit('popup/add', popup);

    return promise;
  },

  resolve(popup, result) {
    popup.resolve(result);
    store.commit('popup/remove', popup);
  },
};
